// localStorage is not guaranteed to exist. Android WebViews without DOM storage
// (common in in-app browsers) expose it as null, and blocked site data makes
// merely touching it throw. In the production bundle an exception inside a
// <script setup> renders the whole component as nothing — that is how the
// address step lost its input — so storage access must never be allowed to throw.

function getStorage() {
    try {
        return window.localStorage ?? null;
    } catch {
        return null;
    }
}

export function storageGet(key) {
    try {
        return getStorage()?.getItem(key) ?? null;
    } catch {
        return null;
    }
}

export function storageSet(key, value) {
    try {
        getStorage()?.setItem(key, value);
    } catch {
        // full, disabled or blocked: nothing is persisted
    }
}

export function storageRemove(key) {
    try {
        getStorage()?.removeItem(key);
    } catch {
        // full, disabled or blocked: nothing to remove
    }
}

export function storageGetJson(key) {
    const raw = storageGet(key);
    if (raw === null) {
        return null;
    }
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}
